'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _INT_ONE = require('permanent/es/INT_ONE');

var _INT_ONE2 = _interopRequireDefault(_INT_ONE);

var _INT_ZERO = require('permanent/es/INT_ZERO');

var _INT_ZERO2 = _interopRequireDefault(_INT_ZERO);

var _slice2 = require('./_internal/_slice');

var _slice3 = _interopRequireDefault(_slice2);

var _apply = require('./apply');

var _apply2 = _interopRequireDefault(_apply);

var _call = require('./call');

var _call2 = _interopRequireDefault(_call);

var _compose = require('./compose');

var _compose2 = _interopRequireDefault(_compose);

var _getProp = require('./getProp');

var _getProp2 = _interopRequireDefault(_getProp);

var _spread = require('./spread');

var _spread2 = _interopRequireDefault(_spread);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create a function which executes a function with each arg being transformed
 * by a function
 *
 * @module executeWith
 * @func
 * @since 1.11.0
 * @param {function} fn
 * @param {...*} args
 * @return {function}
 * @example
 *
 *     const foo = (a, b) => a + b;
 *     const add1 = a => a + 1;
 *     const add2 = b => b + 2;
 *     executeWith(foo, add1, add2)(0, 0); //=> 3
 *     executeWith(foo, add1)(0, 0); //=> 1
 */

var getPropZero = (0, _getProp2.default)(_INT_ZERO2.default);
var executeWith = function executeWith(arr) {
  var fn = getPropZero(arr);
  var args = (0, _slice3.default)(arr, _INT_ONE2.default);
  return (0, _compose2.default)((0, _call2.default)(fn), (0, _apply2.default)(args), _spread2.default);
};

exports.default = (0, _compose2.default)(executeWith, _spread2.default);